$(document).ready(function () {

    function closeMenu() {
        $("modal-container").removeClass("open");
        $(".desktop-menu-buttons modal-open").removeClass("active");
        $("body").removeClass("menu-open");
        $(".menu-link.parent").removeClass("hidden");
        $("child-menu").removeClass("active");
    }

    // Open / Close Menu
    $(document).on("click", ".desktop-menu-buttons modal-open", function (e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent sticky-header click

        var target = $(this).attr("target");
        var $modal = $("#" + target);

        if ($(this).hasClass("active")) {
            closeMenu();
            return;
        }

        closeMenu();

        $(this).addClass("active");
        $modal.addClass("open");
        $("body").addClass("menu-open");
    });

    // Close button
    $(document).on("click", "modal-close", function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
    });

    // Prevent dialog click
    $(document).on("click", "modal-container dialog", function (e) {
        e.stopPropagation();
    });

    // Click outside dialog
    $(document).on("click", "modal-container.open", function (e) {
        if (!$(e.target).closest("dialog").length) {
            closeMenu();
        }
    });

    // Sticky Header click -> Close
    $(document).on("click", ".header-wrapper ", function () {
        closeMenu();
    });

});

$('.content-menu').on('scroll', function () {
    if ($(this).scrollTop() > 0) {
        $('body').addClass('active-menu');
    } else {
        $('body').removeClass('active-menu');
    }
});